import { Box, IconButton, Stack, SxProps, Theme, Tooltip, Typography } from '@mui/material'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import { SectionDefinition } from './Sections.types'
import SectionIcon from './SectionIcon.component'

type DetailSectionProps = {
  section: SectionDefinition
  // when provided, shows an edit button that should open the edit form at this section
  onEdit?: () => void
  action?: React.ReactNode
  sx?: SxProps<Theme>
  children: React.ReactNode
}
/**
 * @description Read-only card for one section of an entity's detail page.
 */
const DetailSection = (props: DetailSectionProps) => {
  const { section, onEdit, action, sx, children } = props
  return (
    <Box
      component="section"
      aria-label={section.title}
      sx={[
        {
          height: '100%',
          p: 2,
          border: 1,
          borderColor: 'divider',
          borderRadius: 1,
          // a little lighter than the card behind it
          bgcolor: 'surface.section',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
        <SectionIcon icon={section.icon} />
        <Typography variant="h6" component="h3" sx={{ flex: 1, lineHeight: 1.3 }}>
          {section.title}
        </Typography>
        {action}
        {onEdit && (
          <Tooltip title={`Edit ${section.title}`}>
            <IconButton size="small" onClick={onEdit} aria-label={`Edit ${section.title}`}>
              <EditOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
      <Stack spacing={2}>{children}</Stack>
    </Box>
  )
}
export default DetailSection
